/**
 * NEWT FORM Consumer API For Consumer UI
 * NEWT FORM コンシューマ UI からコールされる コンシューマ API です。   
 *
 * The version of the OpenAPI document: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { FormPagePropertyItemPasswordHashErrorMessage } from './formPagePropertyItemPasswordHashErrorMessage';
import { FormPagePropertyItemReEnterSetting } from './formPagePropertyItemReEnterSetting';
import { FormPagePropertyItemPasswordHashAllOf } from './formPagePropertyItemPasswordHashAllOf';
import { FormPagePropertyItemPasswordHashInputFormat } from './formPagePropertyItemPasswordHashInputFormat';
import { FormPagePropertyItemStringConvertRule } from './formPagePropertyItemStringConvertRule';
import { PasswordRequiredCharacterType } from './passwordRequiredCharacterType';


/**
 * パスワードハッシュ型の入力項目を表す。パスワードハッシュ型は必須扱いとなる。
 */
export interface FormPagePropertyItemPasswordHash { 
    /**
    * フォーム入力項目大種別
    */
    propertyType: 'passwordHash';
    /**
    * 入力項目ID
    */
    propertyId: string;
    /**
    * 項目名(管理機能のopenapiではdisplay_name）
    */
    name: string;
    /**
    * 項目のコメント(管理機能のopenapiではdisplay_comment）
    */
    comment?: string;
    /**
    * 注意書き・凡例(管理機能のopenapiではcaution）
    */
    note?: string;
    /**
    * 必須/任意のラベルを表示するかどうか.
    */
    displayRequiredLabel: boolean;
    stringConvertRule?: FormPagePropertyItemStringConvertRule;
    type: FormPagePropertyItemPasswordHash.TypeEnum;
    /**
    * 入力可能な最大文字数。超えた場合はバリデーションエラー
    */
    maxLength: number;
    /**
    * 入力可能な最小文字数。下回る場合はバリデーションエラー
    */
    minLength: number;
    /**
    * 入力可能なパスワードを正規表現として表現. 使用可能な文字種と必須とする文字種のチェックを行う. 正規表現にマッチしない場合は「入力エラーメッセージ」を表示するs
    */
    pattern: string;
    /**
    * 必須とする文字種を定義
    */
    requiredCharacterTypes: Array<PasswordRequiredCharacterType>;
    reEnter?: FormPagePropertyItemReEnterSetting;
    inputFormat: FormPagePropertyItemPasswordHashInputFormat;
    errorMessage?: FormPagePropertyItemPasswordHashErrorMessage;
}

export namespace FormPagePropertyItemPasswordHash {
    export type TypeEnum = 'string';
    export const TypeEnum = {
        String: 'string' as TypeEnum
    };
}


